<template>
  <modal :title="'Unbillings'" @close="$emit('close')">
    >
    <template #content>
      <div
        v-if="data != null"
        class="head row m-0 border-bottom p-t-5 p-l-5 p-r-5 p-b-5 align-items-center justify-content-end"
      >
        <div class="col-xs-12 col-sm-auto p-t-5 p-b-5">
          <button
            class="btn btn-info btn-icon waves-effect waves-light p-r-20 m-l-5"
            type="button"
            @click="addPopShow = true"
          >
            <span class="btn-label m-0 p-0"><i class="fa fa-plus"></i></span>
            <span class="p-l-20 p-r-10">Add Unbillings</span>
          </button>
        </div>
      </div>
      <load-area v-if="data == null"></load-area>

      <dataTable
        :name="'CustomerProviderHotelCodes'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="data"
        @update="updatePopShow = $event"
        @remove="remove"
        v-if="data != null"
      ></dataTable>
    </template>
  </modal>
  <upsert
    v-if="addPopShow || updatePopShow != null"
    :addId="hotelId"
    :setModel="updatePopShow"
    @add="$refs.agGrid.addRow([$event])"
    @update="$refs.agGrid.changeRow('Id', $event)"
    @close="
      addPopShow = false;
      updatePopShow = null;
    "
  ></upsert>
</template>

<script>
import upsert from "./upsert.vue";
export default {
  name: "Unbillings",
  props: ["hotelId"],
  components: { upsert },
  data() {
    return {
      columnDefs: [
        {
          headerName: "Field Type",
          field: "FieldType",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 100,
          valueGetter: (params) => {
            if (params.data.FieldType == 1) return "Agency";
            else if (params.data.FieldType == 2) return "Provider";
            else return params.data.FieldType;
          },
        },
        {
          headerName: "Value",
          field: "FieldValue",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          flex: 1,
          minWidth: 100,
        },
        {
          headerName: "IsActive",
          field: "IsActive",
          enableRowGroup: true,
          floatingFilter: true,
          filter: "agTextColumnFilter",
          width: 100,
          cellRenderer: this.$CheckCellRenderer,
        },
        {
          headerName: "",
          type: "action",
          width: 75,
          buttons: [
            {
              classes: "btn btn-xs waves-effect waves-light btn-warning",
              text: '<i class="fas fa-pencil-alt"></i>',
              emit: "update",
            },
            {
              classes: "btn btn-xs waves-effect waves-light btn-danger",
              text: '<i class="fas fa-trash-alt"></i>',
              emit: "remove",
            },
          ],
          filter: false,
          sortable: false,
          resizable: false,
          floatingFilter: false,
        },
      ],
      data: null,
      addPopShow: false,
      updatePopShow: null,
    };
  },
  created() {
    this.$appAxiosAdmin.get("Hotels/FidelioUnbillings/" + this.hotelId).then((response) => {
      this.data = response.data;
    });
  },
  methods: {
    remove(item) {
      this.$swal({
        icon: "question",
        title: "Warning",
        text:
          "Are you sure you want to delete the unbilling " + item.FieldValue + "?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((question) => {
        if (question.isConfirmed) {
          this.$appAxiosAdmin
            .delete(`Hotels/FidelioUnbillings/` + item.Id)
            .then(() => {
              this.$refs.agGrid.removeRow([item]);
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Unbilling deleted successfully.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
            })
            .catch((err) => {
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
